import React from 'react';
// import styled from 'styled-components';


// import GlobalStyled from '../styles/GlobalStyle';

function PropertyHeader({address, key_details}){
    return (
        <div> 
            <h1>{address}</h1>
            { getWidth() < 580 &&
            <h2>{ key_details.bedrooms} <br/>  { key_details.bathrooms} <br/> { key_details.sqFootage} <br/>  { key_details.price}</h2>
            }
            { getWidth() >= 580 && getWidth() <= 1120 &&
            <h2>{ key_details.bedrooms} | { key_details.bathrooms} <br/> { key_details.sqFootage} | { key_details.price}</h2>
            }
            { getWidth() > 1120 &&
            <h2>{ key_details.bedrooms} | { key_details.bathrooms} | { key_details.sqFootage} | { key_details.price}</h2>
            }
        </div>
    )
}

const getWidth = () => {
    let width = window.innerWidth;
    return width
  }

// const SidebarStyled = styled.div`
//     width:16.3rem;
//     height:100vh;
//     background-color:var(--side-bar-dark-color);
//     position:fixed;
// `;

export default PropertyHeader;